import { BoardContainer } from "./BoardContainer";
import { AudioManager } from "../../../AudioManager";

export class Bus extends Phaser.GameObjects.Container {

    private img: Phaser.GameObjects.Image;
    private currentPos: number;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = BoardContainer.POSITION_BUS[BoardContainer.POSITION_START[0]].x;
        this.y = BoardContainer.POSITION_BUS[BoardContainer.POSITION_START[0]].y;

        this.currentPos = 0;

        this.img = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "bus_10");
        this.img.setScale(.9);
        this.add(this.img);
    }

    public moveBusTo(newPos: number): number {

        AudioManager.playSound("bus_moves");

        if (newPos === this.currentPos) {
            return 0;
        }

        let positions = [];

        if (newPos > this.currentPos) {
            for (let i = this.currentPos; i <= newPos; i++) {
                positions.push(i);
            }
        } else {
            for (let i = this.currentPos; i < BoardContainer.POSITION_BUS.length; i++) {
                positions.push(i);
            }

            for (let i = 0; i <= newPos; i++) {
                positions.push(i);
            }
        }

        var timeline = this.scene.tweens.createTimeline();
        var duration = 0;

        for (let i = 1; i < positions.length; i++) {

            let x = BoardContainer.POSITION_BUS[positions[i]].x - BoardContainer.POSITION_BUS[positions[i - 1]].x;
            let y = BoardContainer.POSITION_BUS[positions[i]].y - BoardContainer.POSITION_BUS[positions[i - 1]].y;
            let dist = Math.sqrt(x * x + y * y);
            let time = dist * 2;

            timeline.add({
                targets: this,
                x: BoardContainer.POSITION_BUS[positions[i]].x,
                y: BoardContainer.POSITION_BUS[positions[i]].y,
                ease: Phaser.Math.Easing.Linear.Linear,
                duration: time,
                onComplete: () => {
                    this.setImage(BoardContainer.POSITION_BUS[positions[i]].id);
                },
                onStartScope: this
            });

            duration += time;
        }

        timeline.play();

        this.currentPos = newPos;

        return duration;
    }

    public setImage(id: number): void {

        this.img.setFrame("bus_" + id);
    }
}
